import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import preview from 'vue-photo-preview';
import 'vue-photo-preview/dist/skin.css';
Vue.config.productionTip = false

import BaiduMap from 'vue-baidu-map';
Vue.use(BaiduMap, {
  ak: 'MOEN2tGXZ5OldKlApggZgCUpfOZpFfjf'
});
Vue.use(preview);
// import Auth from 'utils/auth.js';

// // 微信网页端授权实例
// Auth({
//   cacheName: 'cbgcAuth',
//   // type: 'token',
//   refresh: 1
// }).then(res=>{
//   console.log('res:', res);
// });

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
